<template>
  <div>
    <NotificationBox v-if="billing.showPricesAfterDiscount" hideCloseButton>
      <template v-slot:icon>
        <div class="notification__play-icon">
          <img src="@/assets.app/images/celebrate.svg" alt="" />
        </div>
      </template>
      <template v-slot:title>Your discount has been applied!</template>
      <template v-slot:text>
        <p>{{ billing.cancelDiscountAlertText }}</p>
      </template>
      <template v-slot:link> <i></i> </template>
    </NotificationBox>

    <NotificationBox v-if="billing.statusMessage">
      <template v-slot:title> Billing Status </template>
      <template v-slot:text>
        <p v-html="billing.statusMessage"></p>
      </template>
      <template v-slot:link> <i></i> </template>
    </NotificationBox>

    <NotificationBox v-if="billing.afterCancelTrialAlert">
      <template v-slot:icon>
        <i></i>
      </template>
      <template v-slot:title> You Have Successfully Canceled </template>
      <template v-slot:text>
        <p>
          You have successfully canceled your subscription during the free trial
          and you will not be charged. You can re-subscribe at any time—we'd
          love to have you back!
        </p>
        <p>
          In the meantime, we'll keep working hard to make Shortform better.
        </p>
      </template>
      <template v-slot:link> <i></i> </template>
    </NotificationBox>

    <NotificationBox v-if="billing.afterCancelPaidAlert">
      <template v-slot:icon>
        <i></i>
      </template>
      <template v-slot:title> You Have Successfully Canceled </template>
      <template v-slot:text>
        <p>
          You've canceled your subscription and you will not be charged again in
          the future. You can re-subscribe at any time—we'd love to have you
          back!
        </p>
        <p>
          In the meantime, we'll keep working hard to make Shortform better.
        </p>
      </template>
      <template v-slot:link> <i></i> </template>
    </NotificationBox>

    <NotificationBox v-if="billing.subscribedAlert">
      <template v-slot:icon>
        <div
          v-if="billing.plan.id === 'plan_annual'"
          class="notification__play-icon"
        >
          <img src="@/assets.app/images/celebrate.svg" alt="" />
        </div>
        <span v-else></span>
      </template>
      <template v-slot:title>
        <span v-if="billing.plan.id === 'plan_annual'">
          You've successfully changed to the annual plan!
        </span>
        <span v-else> You've successfully changed to the monthly plan. </span>
      </template>
      <template v-slot:text>
        <p v-if="billing.plan.id === 'plan_annual'">
          You now save {{ billing.switchToAnnualSavings.percent }}% on your
          Shortform subscription. Wise choice!
        </p>
        <p v-else>
          Change back to the annual plan anytime to save
          {{ billing.switchToAnnualSavings.percent }}% off the subscription
          price.
        </p>
      </template>
      <template v-slot:link>
        <router-link :to="{ name: 'books' }" class="btns"
          >Open Books</router-link
        >
      </template>
    </NotificationBox>

    <NotificationBox v-if="billing.resubscribedAlert">
      <template v-slot:icon>
        <div
          v-if="billing.plan.id === 'plan_annual'"
          class="notification__play-icon"
        >
          <img src="@/assets.app/images/celebrate.svg" alt="" />
        </div>
        <span v-else></span>
      </template>
      <template v-slot:title>
        <span v-if="billing.plan.id === 'plan_annual'">
          You've successfully resubscribed to the annual plan!
        </span>
        <span v-else>
          You've successfully resubscribed to the monthly plan!
        </span>
      </template>
      <template v-slot:text> <span></span> </template>
      <template v-slot:link>
        <router-link :to="{ name: 'books' }" class="btns"
          >Open Books</router-link
        >
      </template>
    </NotificationBox>

    <NotificationBox v-if="billing.downgradedAlert">
      <template v-slot:icon>
        <span></span>
      </template>
      <template v-slot:title>
        <span>
          You've successfully downgraded to the Monthly plan! Your Annual plan
          will continue until {{ billing.billingPeriodEnd }} and then will
          switch to Monthly.
        </span>
      </template>
      <template v-slot:text> <span></span> </template>
      <template v-slot:link>
        <router-link :to="{ name: 'books' }" class="btns"
          >Open Books</router-link
        >
      </template>
    </NotificationBox>

    <NotificationBox v-if="billing.upgradedAlert">
      <template v-slot:icon>
        <span></span>
      </template>
      <template v-slot:title>
        <span>
          You've successfully upgraded to the Annual plan! Your Monthly plan
          will continue until {{ billing.billingPeriodEnd }} and then will
          switch to Annual.
        </span>
      </template>
      <template v-slot:text> <span></span> </template>
      <template v-slot:link>
        <router-link :to="{ name: 'books' }" class="btns"
          >Open Books</router-link
        >
      </template>
    </NotificationBox>

    <NotificationBox v-if="billing.subscribedAlertAndRedirect">
      <template v-slot:icon>
        <div class="notification__play-icon">
          <img src="@/assets.app/images/celebrate.svg" alt="" />
        </div>
      </template>
      <template v-slot:title> Welcome to Shortform! </template>
      <template v-slot:text>
        <p>
          You now have full access to Shortform. We'll redirect you to books
          shortly...
        </p>
      </template>
      <template v-slot:link>
        <router-link :to="{ name: 'books' }" class="btns btns--large"
          >Open Books</router-link
        >
      </template>
    </NotificationBox>
  </div>
</template>

<script setup lang="ts">
import type { BillingView } from '@/models/billing'

import NotificationBox from '@/components/ui/NotificationBox.vue'

defineProps<{
  billing: BillingView
}>()
</script>
